module.exports = __webpack_public_path__ + "img/woodroundshield.00e78579.png";